module.exports = __webpack_public_path__ + "img/spider.b9e5a62c.png";